import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isLoggedIn()) {
        return true;
    }
    return router.createUrlTree(['/login']);
};

export const loginGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // Si déjà connecté, ne pas afficher le login
    if (auth.isLoggedIn()) {
        return router.createUrlTree(['/home']);
    }
    return true;
};
